import { ExportFilesTableView } from './Table';

export const ExportFilesList = () => {
  return <ExportFilesTableView />;
};
